import request from '@/utils/request'

export function loginByUsername (username, password, captcha) {
  const data = {
    username,
    password,
    captcha
  }
  return request({
    url: '/auth/api/auth/login',
    method: 'post',
    data
  })
}

export function logout () {
  return request({
    url: '/auth/api/auth/logout',
    method: 'post'
  })
}

export function getUserInfo (token) {
  return request({
    url: '/auth/api/auth/info',
    method: 'get',
    params: { token }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js